import { c as _c } from "react/compiler-runtime";
import { CommunityMemberOverview } from "@/entities/IProfile";
import { SortDirection } from "@/entities/ISort";
import { CommunityMembersSortOption } from "@/enums";
import CommunityMembersMobileCard from "./CommunityMembersMobileCard";
import CommunityMembersTableHeader from "./CommunityMembersTableHeader";
import CommunityMembersTableRow from "./CommunityMembersTableRow";
import CommunityMembersMobileFilterBar from "./CommunityMembersMobileFilterBar";
export default function CommunityMembersTable(t0) {
  const $ = _c(37);
  const {
    members,
    activeSort,
    sortDirection,
    page,
    pageSize,
    isLoading,
    onSort
  } = t0;
  let t1;
  if ($[0] !== activeSort || $[1] !== isLoading || $[2] !== onSort || $[3] !== sortDirection) {
    t1 = <CommunityMembersTableHeader activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} onSort={onSort} />;
    $[0] = activeSort;
    $[1] = isLoading;
    $[2] = onSort;
    $[3] = sortDirection;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== members || $[6] !== page || $[7] !== pageSize) {
    let t3;
    if ($[9] !== page || $[10] !== pageSize) {
      t3 = (member, index) => <CommunityMembersTableRow key={member.detail_view_key} member={member} rank={index + 1 + (page - 1) * pageSize} />;
      $[9] = page;
      $[10] = pageSize;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = members.map(t3);
    $[5] = members;
    $[6] = page;
    $[7] = pageSize;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[12] !== t2) {
    t3 = <tbody className="tw-divide-y tw-divide-solid tw-divide-iron-700">{t2}</tbody>;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t1 || $[15] !== t3) {
    t4 = <div className="tw-hidden sm:tw-block"><table className="tw-min-w-full">{t1}{t3}</table></div>;
    $[14] = t1;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== activeSort || $[18] !== isLoading || $[19] !== onSort || $[20] !== sortDirection) {
    t5 = <CommunityMembersMobileFilterBar activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} onSort={onSort} />;
    $[17] = activeSort;
    $[18] = isLoading;
    $[19] = onSort;
    $[20] = sortDirection;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== members || $[23] !== page || $[24] !== pageSize) {
    let t7;
    if ($[26] !== page || $[27] !== pageSize) {
      t7 = (member_0, index_0) => <CommunityMembersMobileCard key={member_0.detail_view_key} member={member_0} rank={index_0 + 1 + (page - 1) * pageSize} />;
      $[26] = page;
      $[27] = pageSize;
      $[28] = t7;
    } else {
      t7 = $[28];
    }
    t6 = members.map(t7);
    $[22] = members;
    $[23] = page;
    $[24] = pageSize;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[29] !== t6) {
    t7 = <div className="tw-flex tw-flex-col tw-gap-y-4 tw-mt-2">{t6}</div>;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== t5 || $[32] !== t7) {
    t8 = <div className="sm:tw-hidden">{t5}{t7}</div>;
    $[31] = t5;
    $[32] = t7;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== t4 || $[35] !== t8) {
    t9 = <>{t4}{t8}</>;
    $[34] = t4;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  return t9;
}